<script setup lang="ts">
const props = defineProps<{
  title: string;
  subtitle: string;
  comment?: string;
  destination?: string;
}>();
</script>

<template>
  <div class="flex overflow-hidden rounded-lg bg-[#fafafa] shadow-md">
    <!-- Blue Strip -->
    <div class="w-2 bg-primary-500"></div>
    <div class="flex w-full items-center justify-between px-2 py-2">
      <!-- Content -->
      <div>
        <p class="font-bold text-sm text-primary-950">
          {{ props.title }}
        </p>
        <p class="text-xs text-primary-950">{{ props.subtitle }}</p>
        <p v-if="props.comment" class="text-xs text-primary-950">{{ props.comment }}</p>
      </div>
      <!-- <div class="text-left min-w-20">
            <p class="text-primary-950 text-xs">Total</p>
            <p class="text-primary-950 text-sm font-bold">{{ props.price }}</p>
          </div> -->
    </div>
  </div>
</template>

<style scoped></style>
